import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AppProvider } from './state/AppState';
import { registerServiceWorker } from './lib/push';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root element is missing');

createRoot(container).render(
  <StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </StrictMode>,
);

// Register the service worker in production builds only (dev keeps HMR clean).
if (import.meta.env.PROD) {
  void registerServiceWorker();
}
